import { queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  introspeccionColumnas,
  introspeccionTablas,
  listarConfiguraciones,
  listarRoles,
  listarUsuarios,
} from "../services/admin-reporteria.api";

export const configsAdminQueryOptions = queryOptions({
  queryKey: qk.repAdminConfigs,
  queryFn: listarConfiguraciones,
});

export function useConfigsAdmin() {
  return useQuery(configsAdminQueryOptions);
}

export function useIntrospeccionTablas() {
  return useQuery({
    queryKey: qk.repAdminTablas,
    queryFn: introspeccionTablas,
    staleTime: 10 * 60_000,
  });
}

export function useIntrospeccionColumnas(esquema: string | null, tabla: string | null) {
  return useQuery({
    queryKey: qk.repAdminColumnas(esquema ?? "", tabla ?? ""),
    queryFn: () => introspeccionColumnas(esquema!, tabla!),
    enabled: !!esquema && !!tabla,
    staleTime: 10 * 60_000,
  });
}

export function useRolesReporteria() {
  return useQuery({ queryKey: qk.repAdminRoles, queryFn: listarRoles, staleTime: 10 * 60_000 });
}

export function useUsuariosReporteria() {
  return useQuery({ queryKey: qk.repAdminUsuarios, queryFn: listarUsuarios, staleTime: 5 * 60_000 });
}
